import { useNavigate } from 'react-router'

export function Cancel() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col items-center py-12">
      <>
        <h1 className="text-4xl font-bold text-red-600">Something went wrong </h1>

        <button
          className="mt-4 rounded-lg bg-blue-600 px-6 py-2 text-white"
          onClick={() => navigate('/pricing')}>
          Try again
        </button>
      </>
    </div>
  )
}
